export default __webpack_public_path__ + "static/media/pros-cons-sourcing-from-wholesale-distributors.95689dbc.svg";